module.exports = __webpack_public_path__ + "static/wand_of_lightning_bolts-6092fc9bb8d37f2b58739d5620d5d8ff.jpeg";